module.exports = __webpack_public_path__ + "img/blur.e17a27e5.jpg";